import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { ReactElement, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { IPaymentsSummaryCollection } from 'features/PaymentsSummary/collections'
import { PaymentSummaryStatus } from 'features/PaymentsSummary/components/Status'
import { useLogin } from 'features/Login/hooks'
import { canWrite } from 'features/Users/utils'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { PaymentsSummaryListActions } from 'features/PaymentsSummary/components/PaymentsSummaryListActions'
import Drawer from 'components/v2/Drawer'
import { IPaymentSummaryModel } from 'features/PaymentsSummary/types'
import { PaymentSummaryTimeline } from 'features/PaymentsSummary/components/PaymentSummaryTimeline'
import { NavLink } from 'react-router-dom'
import { StyledLink } from 'components/v2/Link'

const PaymentSummaryName = styled.div`
  color: #5d59d4;
  cursor: pointer;
  text-decoration: underline;
`
interface IPaymentsSumaryListProps {
  paymentsSummaryCollection: IPaymentsSummaryCollection
}

export const PaymentsSummaryList = ({ paymentsSummaryCollection }: IPaymentsSumaryListProps): ReactElement => {
  const intl = useIntl()
  const login = useLogin()
  const [selectedPaymentSummary, setSelectedPaymentSummary] = useState<IPaymentSummaryModel | undefined>(undefined)

  const canSeeActions = canWrite(FEATURES.PARTNERS_PAYMENT_SUMMARY, login.accessToken.policies)

  return (
    <div>
      <TableContainer overflow>
        <Table>
          <Thead>
            <Tr>
              {canSeeActions && <Th />}
              <Th>
                <FormattedMessage id="paymentsSummary.list.periodName" defaultMessage="Period Name" />
              </Th>
              <Th>
                <FormattedMessage id="paymentsSummary.list.date" defaultMessage="Date" />
              </Th>
              <Th>
                <FormattedMessage id="paymentsSummary.list.status" defaultMessage="Status" />
              </Th>
              <Th>
                <FormattedMessage id="paymentsSummary.list.emails" defaultMessage="Emails Sent" />
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {paymentsSummaryCollection.items.map((paymentSummary) => {
              const handleNameClick = (): void => setSelectedPaymentSummary(paymentSummary)

              return (
                <Tr key={paymentSummary.id}>
                  {canSeeActions && (
                    <Td>
                      <PaymentsSummaryListActions paymentSummary={paymentSummary} />
                    </Td>
                  )}
                  <Td>
                    <PaymentSummaryName onClick={handleNameClick}>{paymentSummary.name}</PaymentSummaryName>
                  </Td>
                  <Td>
                    <FormattedDate
                      intl={intl}
                      value={paymentSummary.createdAt}
                      month="2-digit"
                      day="2-digit"
                      year="numeric"
                    />
                  </Td>
                  <Td>
                    <PaymentSummaryStatus status={paymentSummary.status} />
                  </Td>
                  <Td>
                    {paymentSummary.emails.length > 0 ? (
                      <StyledLink as={NavLink} to={`/partners/payment-summary/${paymentSummary.id}/emails`}>
                        {paymentSummary.emails.length}
                      </StyledLink>
                    ) : (
                      0
                    )}
                  </Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      </TableContainer>
      <Drawer.Container isOpen={!!selectedPaymentSummary} onClose={(): void => setSelectedPaymentSummary(undefined)}>
        <PaymentSummaryTimeline timeline={selectedPaymentSummary?.timeline || []} />
      </Drawer.Container>
    </div>
  )
}
